webpackJsonp([84779536864874],{

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _NextButton = __webpack_require__(62);
	
	var _NextButton2 = _interopRequireDefault(_NextButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'Get started' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'react-day-picker is designed to cover the most common needs for a date picker in web applications. This package includes:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'DayPicker'
	        ),
	        ' component to render the calendar (see:',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/docs/basic-concepts' },
	          'basic concepts'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/api/DayPicker' },
	          'API'
	        ),
	        ')'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'the',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/docs/input' },
	          _react2.default.createElement(
	            'code',
	            null,
	            'DayPickerInput'
	          )
	        ),
	        ' ',
	        'component to render an input field opening the DayPicker in an overlay'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Setup'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'As dependency'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Install as dependency to use it in your project:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      { language: 'bash' },
	      '$ npm install react-day-picker --save \n# or with yarn \n$ yarn add react-day-picker'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then import the component and its style into your component:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import DayPicker from \'react-day-picker\';\n\n// Or import the input component\nimport DayPickerInput from \'react-day-picker/DayPickerInput\';\n\nimport \'react-day-picker/lib/style.css\';'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Use from unpkg'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Include the component without installing:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      { language: 'html' },
	      '<script src="https://unpkg.com/react-day-picker/lib/daypicker.min.js"></script>\n<link rel="stylesheet" href="https://unpkg.com/react-day-picker/lib/style.css">'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The components will be available as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'window.DayPicker'
	      ),
	      ' and',
	      ' ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'window.DayPicker.Input'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage example'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'getting-started' }),
	    _react2.default.createElement(_NextButton2.default, { to: '/docs/basic-concepts', label: 'Basic concepts' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-getting-started-js-cca289942e3dc306ef09.js